import axios from "../http";

let module = "/transfer";

function getStudentTransfer(data) {
    return axios.post(module+"/"+data.studentId, data);
}

export default {
    getStudentTransfer
}
